import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    cardSelected: {
        borderColor: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    cardLabelContent: {
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: "transparent",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: theme.spacing(2),
        flex: 1,
        padding: theme.spacing(2, 2.5),
        borderRadius: theme.spacing(1),
    },
    cardDateFields: {
        marginTop: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5),
        paddingLeft: theme.spacing(8),
        borderTop: `1px solid ${theme.palette.emteria.border.primary}`,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        width: "100%",
    },
    datePickerField: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    },
    content: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(1),
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        padding: theme.spacing(2, 3),
        borderTop: `1px solid ${theme.palette.emteria.border.primary}`,
        flexShrink: 0,
    },
    disabledButtonWrapper: {
        display: "inline-flex",
    },
    descriptionText: {
        paddingLeft: theme.spacing(8),
    },
}));
